"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=algoliaProduct.js.map